export const hasElement = className => {
  return document.getElementsByClassName(className).length > 0
}
